var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-colored-el",
    stroke: "#333",
    strokeWidth: 2,
    d: "M4 15h12M6 9l3.93 3.93a.1.1 0 00.14 0L14 9m-4 4V4",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  })));
};
export default SvgDownload;